// tim trailing spaces in an object that's of type "string"
export const trimObject = (obj) => {
  Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k])
  return obj
}

export const trimValue = (val) => {
  return (typeof val === 'string') ? val.trim() : val
}